import { useEffect, useState } from "react";
import { FaPaperPlane, FaTrash, FaTrashCan } from "react-icons/fa6";
import { SelectPppoeUser } from "../../../../../components/forms/selects/SelectPppoeUser";
import { PppoeUserService } from "../../../../../services/PppoeUserService";
import { SelectPppoeStatus } from "../../../../../components/forms/selects/SelectPppoeStatus";
import { ModalWraper } from "../../../../../components/modal/wraper";
import { ModalWraperConfirmDelete } from "../../../../../components/modal/wraper_confirm_delete";
import { OltService } from "../../../../../services/OltService";



export const ConfirmDeleteOlt = ({
    refresh,
    openModal,
    setOpenModal,
    status,
    id
}) => {
    const [loading, setLoading] = useState(false);

    const closeModal = () => {
        setOpenModal(false);
        setLoading(false);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            await OltService.delete({ id: id});
            refresh();
            closeModal();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalWraperConfirmDelete
            isOpen={openModal}
            setIsOpen={setOpenModal}
        >
            <form
                onSubmit={handleSubmit}
                className="space-y-5"
            >
                <div className="flex gap-3">
                    <button
                        type="button"
                        onClick={closeModal}
                        className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300"
                    >
                        Batal
                    </button>

                    <button
                        type="submit"
                        disabled={loading}
                        className="flex-1 py-3 rounded-xl bg-red-600 hover:bg-red-500 disabled:bg-slate-700 text-white font-semibold flex items-center justify-center gap-2"
                    >
                        {loading ? (
                            <>Menghapus...</>
                        ) : (
                            <>
                                <FaTrash />
                                Hapus
                            </>
                        )}
                    </button>
                </div>
            </form>
        </ModalWraperConfirmDelete>
    );
};